export const MEDIA_UPLOAD_REGION_TO_URL = {
  AU: 'https://media-upload.au.whispir.com/media',
  AP1: 'https://media-upload.ap1.whispir.com/media',
  US: 'https://media-upload.us.whispir.com/media',
};
